/**
 * PostHog SPA client configuration factory.
 *
 * This module provides a canonical factory for configuring PostHog.js
 * in single-page applications, following PostHog's standard configuration
 * patterns.
 *
 *
 * Usage:
 * ```ts
 * import { createPosthogSpaConfig } from '@testfeed/observability/posthog-spa';
 *
 * const config = createPosthogSpaConfig({
 *   token: process.env.NEXT_PUBLIC_POSTHOG_TOKEN!,
 *   apiHost: process.env.NEXT_PUBLIC_POSTHOG_API_HOST!,
 *   uiHost: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST!,
 *   capturePageview: true,
 *   capturePageleave: true,
 *   captureWebVitals: true,
 *   inApp: false,
 * });
 * posthog.init(config);
 * ```
 */
/**
 * Create PostHog SPA configuration with sensible defaults.
 *
 * Provides a clean factory for PostHog.js initialization with
 * recommended capture settings for web applications.
 *
 * @param input - Configuration parameters for PostHog SPA setup
 * @returns PostHog configuration object ready for posthog.init()
 */
export function createPosthogSpaConfig(input) {
    const { token, apiHost, uiHost, capturePageview = true, capturePageleave = true, captureWebVitals = true, inApp = false, } = input;
    return {
        api_host: apiHost,
        ...(uiHost && { ui_host: uiHost }),
        token,
        capture_pageview: capturePageview,
        capture_pageleave: capturePageleave,
        capture_web_vitals: captureWebVitals,
        ...(inApp && { in_app: true }),
    };
}
//# sourceMappingURL=posthog-spa.js.map